import React, { useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";

const HeaderUploadComponent = ({ onFileUpload }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [aspect, setAspect] = useState(4 / 1); // Default aspect ratio

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleSetHeaderImage = async () => {
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      onFileUpload(croppedImage);
    } catch (e) {
      console.error(e);
    }
  };

  const handleAspectChange = (newAspect) => {
    setAspect(newAspect);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Upload your header image:
      </label>
      <input
        type="file"
        onChange={handleFileUpload}
        className="form-input rounded-md shadow-sm"
        accept="image/*"
      />
      {imageSrc && (
        <div>
          <div className="relative w-full h-64 bg-gray-200">
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={aspect}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>
          <div className="flex justify-between mt-2">
            <button
              onClick={() => setZoom((zoom) => Math.min(zoom + 0.1, 3))}
              className="py-2 px-4 bg-blue-500 text-white rounded"
            >
              Zoom In
            </button>
            <button
              onClick={() => setZoom((zoom) => Math.max(zoom - 0.1, 1))}
              className="py-2 px-4 bg-blue-500 text-white rounded"
            >
              Zoom Out
            </button>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Aspect Ratio:
              </label>
              <select
                value={aspect}
                onChange={(e) => handleAspectChange(Number(e.target.value))}
                className="form-select rounded-md shadow-sm"
              >
                <option value={1}>1:1</option>
                <option value={4 / 3}>4:3</option>
                <option value={16 / 9}>16:9</option>
                <option value={4 / 1}>4:1</option>
              </select>
            </div>
            <button
              onClick={handleSetHeaderImage}
              className="py-2 px-4 bg-green-500 text-white rounded"
            >
              Set Header Image
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderUploadComponent;
